import { getNotionToken, NOTION_DATABASE_ID, API_URL } from '../config';

// 용어 목록 가져오기
export const fetchTerms = async () => {
  console.log('🔄 용어 데이터 로딩 시작...');
  
  try {
    const response = await fetch(`${API_URL}/api/terms`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ message: response.statusText }));
      console.error('❌ API 오류:', errorData);
      throw new Error(`API 오류: ${errorData.message || response.statusText}`);
    }

    const terms = await response.json();
    console.log('✅ 데이터 수신:', terms.length);
    return terms;
  } catch (error) {
    console.error('❌ 용어 데이터 로딩 실패:', error);
    throw error;
  }
};

// 새 용어 추가
export const addTerm = async (termData) => {
  console.log('📝 새 용어 추가 시작:', termData);
  
  try {
    const response = await fetch(`${API_URL}/api/terms`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(termData)
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ message: response.statusText }));
      throw new Error(`API 오류: ${errorData.message || response.statusText}`);
    }

    console.log('✅ 용어 추가 완료');
    return await response.json();
  } catch (error) {
    console.error('❌ 용어 추가 실패:', error);
    throw error;
  }
};

// 용어 수정
export const updateTerm = async (termId, termData) => {
  console.log('📝 용어 수정 시작:', { termId, termData });
  
  try {
    const notionToken = getNotionToken();
    
    const response = await fetch(`https://api.notion.com/v1/pages/${termId}`, {
      method: 'PATCH',
      headers: {
        'Authorization': `Bearer ${notionToken}`,
        'Notion-Version': '2022-06-28',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        properties: {
          Term: {
            title: [
              {
                text: {
                  content: termData.term
                }
              }
            ]
          },
          Definition: {
            rich_text: [
              {
                text: {
                  content: termData.definition
                }
              }
            ]
          },
          Subject: {
            select: {
              name: termData.subject
            }
          },
          Hint: termData.hint ? {
            rich_text: [
              {
                text: {
                  content: termData.hint
                }
              }
            ]
          } : null,
          Keywords: {
            multi_select: termData.keywords.map(keyword => ({
              name: keyword
            }))
          }
        }
      })
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`API 요청 실패: ${response.status} - ${errorText}`);
    }

    console.log('✅ 용어 수정 완료');
    return await response.json();
    
  } catch (error) {
    console.error('❌ 용어 수정 실패:', error);
    throw error;
  }
};

// 용어 삭제
export const deleteTerm = async (termId) => {
  console.log('🗑 용어 삭제 시작:', termId);
  
  try {
    const response = await fetch(`${API_URL}/api/terms/${termId}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json'
      }
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ message: response.statusText }));
      throw new Error(`API 오류: ${errorData.message || response.statusText}`);
    }

    console.log('✅ 용어 삭제 완료');
    return await response.json();
  } catch (error) {
    console.error('❌ 용어 삭제 실패:', error);
    throw error;
  }
}; 